import { useMemo, useState } from 'react';
import {
  List,
  TextField,
  EmailField,
  FunctionField,
  useTranslate,
} from 'react-admin';
import { CustomDatagrid, CrudListActions, RowActionsMenu } from '@/components/common';
import { compactListSx } from '@/components/common/compactListSx';
import {
  CollapsibleFilterPanel,
  FilterExpandContext,
} from '@/components/common/CollapsibleFilterPanel';
import { CustomTextInputFilter } from '@/components/common/CustomFilters';

export const OrganizationList = () => {
  const translate = useTranslate();
  const [filtersExpanded, setFiltersExpanded] = useState(false);
  const filterExpandValue = useMemo(
    () => ({ expanded: filtersExpanded, setExpanded: setFiltersExpanded }),
    [filtersExpanded]
  );

  const filters = useMemo(
    () => [
      <CollapsibleFilterPanel key="filters" source="_cfp" alwaysOn alwaysVisibleCount={0}>
        <CustomTextInputFilter
          source="q"
          label={translate('common.filters.search', { _: 'Buscar' })}
          alwaysOn
        />
      </CollapsibleFilterPanel>,
    ],
    [translate]
  );

  return (
    <FilterExpandContext.Provider value={filterExpandValue}>
      <List
        sx={compactListSx}
        filters={filters}
        actions={<CrudListActions exportColumns={['full_name', 'email', 'company_name', 'contact_no', 'status', 'createdAt']} />}
        sort={{ field: 'user_id', order: 'DESC' }}
        exporter={false}
      >
        <CustomDatagrid primarySource="full_name" secondarySource="email" bulkActionButtons={false}>
          <RowActionsMenu label="" sortable={false} />
          <TextField source="full_name" />
          <EmailField source="email" />
          <TextField source="company_name" />
          <TextField source="contact_no" />
          <FunctionField
            source="status"
            render={(record: any) =>
              record?.status === 1
                ? translate('common.status.active', { _: 'Activa' })
                : translate('common.status.inactive', { _: 'Inactiva' })
            }
          />
        </CustomDatagrid>
      </List>
    </FilterExpandContext.Provider>
  );
};

export default OrganizationList;
